// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_p6-0";
export var buttonContainer = "_p6-3";
export var cancelButton = "_p6-4";
export var headerSection = "_p6-6";
export var headerTitle = "_p6-9";
export var messageSideLeft = "_p6-1";
export var messageSideRight = "_p6-2";
export var orderNumberContainer = "_p6-7";
export var orderNumberLabel = "_p6-8";
export var submitButton = "_p6-5";